import { useMemo, useCallback, memo } from 'react';
import { isMultienum } from 'customer-data-objects/property/PropertyIdentifier';
import emptyFunction from 'react-utils/emptyFunction';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import InternalValueTooltip from './externalOptions/InternalValueTooltip';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { useObjectTypeId } from '../v2/hooks/useObjectTypeId';
import { useProperty } from '../v2/hooks/useProperty';
import { useInternalPropertyValue } from '../v2/hooks/useInternalPropertyValue';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import ReferenceLiteSearchSelect from 'reference-resolvers-lite/components/ReferenceLiteSearchSelect';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputExternalOption = props => {
  const {
    inputRef,
    isRequired,
    onChange = emptyFunction,
    options,
    placeholder,
    multi: multiProp,
    readOnly,
    referenceToOption,
    resolver,
    shouldOverrideValue,
    overrideValue,
    onOpenChange,
    formControlUse
  } = props;
  useComponentMountMetric('PropertyInputExternalOption');
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const internalValue = useInternalPropertyValue();
  let value = usePropertyValue();
  if (shouldOverrideValue) {
    value = overrideValue;
  }
  const multi = multiProp !== null && multiProp !== void 0 ? multiProp : isMultienum(property);
  const handleChange = useCallback(({
    target: {
      value: newValue
    }
  }) => {
    onChange(syntheticEvent(Array.isArray(newValue) ? newValue.join(';') : newValue));
  }, [onChange]);
  const valueProp = useMemo(() => multi ? parseMultiEnumValue(value) : value, [value, multi]);
  const placeholderFallback = formControlUse === 'floating' ? undefined : '';
  const select = /*#__PURE__*/_jsx(ReferenceLiteSearchSelect, Object.assign({}, getTransferrableProps(props), {
    referenceToOption: referenceToOption,
    clearable: !isRequired,
    inputRef: inputRef,
    multi: multi,
    onChange: handleChange,
    options: options,
    placeholder: placeholder || placeholderFallback,
    readOnly: readOnly,
    resolver: resolver,
    value: valueProp,
    deferAutoloadUntilOpen: true,
    onOpenChange: onOpenChange
  }));
  if (readOnly) {
    return /*#__PURE__*/_jsx(InternalValueTooltip, {
      internalValue: internalValue,
      objectTypeId: objectTypeId,
      property: property,
      tooltipAlignment: "end",
      children: select
    });
  }
  return select;
};
export default /*#__PURE__*/memo(PropertyInputExternalOption);